// we use this script to calculate the min and max shipping time and store it in cart attributes
// after every cart:change event. We then use that information in klavyio to build custom flows

/**
 * Returns the min and max shipping time value of a shopify cart with mixed shipping times.
 * If there is a month in the string, we return the value 0
 *
 * @param {array} times The array of different shipping time strings
 * @param {array} monthNames Array of all the month names
 * @return {array} Array with the min and max shipping time values as integers
 */

function findMaxShippingTime(times, monthNames) {
  let maxMin = 0;
  let maxMax = 0;
  let invalidEntryFound = false; // Flag to track invalid entries

  for (let time of times) {
    // Check if the string contains any month name
    if (monthNames.some((month) => time.includes(month))) {
      invalidEntryFound = true;
      break; // Exit the loop early
    }

    const numbers = time.match(/\d+/g)?.map(Number); // Safely extract numbers and convert to Number type

    // Check if there aren't exactly two numbers
    if (!numbers || numbers.length !== 2) {
      invalidEntryFound = true;
      break; // Exit the loop early
    }

    // If valid, update maxMin and maxMax based on the two numbers found
    maxMin = Math.max(maxMin, numbers[0]);
    maxMax = Math.max(maxMax, numbers[1]);
  }

  // Check the flag before returning the result
  if (invalidEntryFound) {
    return [0, 0]; // Return [0, 0] if any invalid entry was found
  } else {
    return [maxMin, maxMax]; // Otherwise, return the max range of shipping time
  }
}

/**
 * Updates the shopify cart attribute with the shipping time min and max values after
 * the cart:change event
 *
 * @param {object} cart The current shopify cart
 * @param {array} monthNames Array of all the month names
 */

const addShippingTimeCartAttribute = (cart, monthNames) => {
  const allShippingTimes = cart.items.map((item) => {
    return item.properties["Versandfertig in"];
  });
  const [maxMin, maxMax] = findMaxShippingTime(allShippingTimes, monthNames);

  if (maxMin && maxMax) {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          "_Lieferzeit Min": maxMin,
          "_Lieferzeit Max": maxMax,
          // Add more attributes as needed
        },
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response.attributes)
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

document.addEventListener("cart:change", (event) => {
  const { cart } = event.detail;
  const monthNames = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ];

  addShippingTimeCartAttribute(cart, monthNames);
});
